import type { ExportFile } from '@kaiizen/kai-floor-plan-editor-core';

/** A browser file download, the web's delivery of an export: the file as a blob, through a temporary link click. */
export const downloadFile = ({ name, type, content }: ExportFile): void => {
  const url = URL.createObjectURL(new Blob([content], { type }));
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = name;
  anchor.click();
  URL.revokeObjectURL(url);
};
